import { http } from "./client";

export const getApplications = (medicaidid) => http.get('Applications/get',{params: {MedicaidID: medicaidid}});
export const getDemographic = (applicationid) => http.get('Applications/demographics',{params: {ApplicationID: applicationid}});
export const addApplication = (payload) => http.post('Applications/add',payload);